import { Component, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { Subject, takeUntil } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';
import { OrderService } from 'src/app/services/api/order.service';
import {
  DetailDataOrderModel,
  orderDetails,
} from 'src/app/models/detail-data-order.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { awbHistoryModel } from 'src/app/models/awb-history.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AwbHistoryModalComponent } from './components/awb-history-modal/awb-history-modal.component';
import { AwbHistoryRequestType } from 'src/app/types/request/awb-histroy-request.type';

@Component({
  standalone: false,
  selector: 'app-detail-data-order',
  templateUrl: './detail-data-order.component.html',
  styleUrls: ['./detail-data-order.component.scss'],
  providers: [{ provide: LOCALE_ID, useValue: 'id' }],
})
export class DetailDataOrderComponent implements OnInit, OnDestroy {
  detailOrder!: DetailDataOrderModel;
  orderDetails: orderDetails[] = [];
  awbHistory: awbHistoryModel[] = [];
  destroy$ = new Subject<void>();
  orderID!: number;
  totalPrice!: number;
  loading: boolean = true;

  paramAwbHistory: AwbHistoryRequestType = {
    shipping: '',
    airway_bill: '',
  };

  constructor(
    private orderService: OrderService,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private modalService: NgbModal,
    private clipboard: Clipboard,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    registerLocaleData(localeId);
    this.getDetailOrder();

    this.activeRoute.params.subscribe((params) => {
      this.orderID = Number(params['id']);
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  back(): void {
    this.route.navigate(['order-data']);
  }

  copyValue(value: string): void {
    this.clipboard.copy(value);
    this.message.create('success', 'Successfully copy Tracking Number');
  }

  openLacakResi(): void {
    const modalRef = this.modalService.open(AwbHistoryModalComponent, {
      scrollable: true,
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.awbHistory = this.awbHistory;
    modalRef.componentInstance.shipping = this.detailOrder.shipping;
    this.getAwbHistory();
  }

  getDetailOrder(): void {
    this.activeRoute.params.subscribe((params) => {
      this.orderID = Number(params['id']);
    });

    this.orderService
      .detailDataOrder(this.orderID)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.detailOrder = res.data;
          this.orderDetails = res.data.order_details;

          this.paramAwbHistory.shipping = res.data.shipping;
          this.paramAwbHistory.airway_bill = res.data.awb;

          const dateParts = this.detailOrder.order_date.split('-');
          const formattedDate = new Date(
            `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
          );
          this.detailOrder.formatted_date = formattedDate;

          const sum: number = res.data.order_details
            .map((item: orderDetails) => item.subtotal)
            .reduce(function (acc: number, val: number) {
              return acc + val;
            });
          this.totalPrice = sum;
          this.getAwbHistory();
        },
        () => {}
      );
  }

  trackPack(url: string): void {
    window.open(url, '_blank');
  }

  getAwbHistory(): void {
    this.orderService
      .awbHistory(this.paramAwbHistory)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.awbHistory = res.data.history;
      });
  }

  submitRequest(): void {
    const params = {
      orders: [
        {
          order_no: this.detailOrder.order_no,
        },
      ],
    };
    this.orderService.requestPickup(params).subscribe(
      (res) => {
        this.message.success('Request submitted successfully!');

        this.getDetailOrder();
      },
      (err) => {
        this.message.error('Request failed to submit, please try again later');
      }
    );
  }

  cancelRequest(): void {
    this.orderService.cancelPickup({ order_no: this.detailOrder.order_no }).subscribe(
      (res) => {
        this.message.success('Request canceled successfully!');
        this.getDetailOrder();
      }, (err) => {
        this.message.error('Request failed to cancel, please try again later');
      }
    );
  }
}
